import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";
import { BASE_DATE_RANGE_PRESETS, PIVOT_DATE_RANGE_PRESETS } from "../common/filters";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Supplier",
    fields: "supplier_id",
    type: FILTER_TYPES.Supplier,
  },
  {
    label: "Supplier Tag",
    fields: "supplier_tag_id",
    type: FILTER_TYPES.SupplierTag,
  },
  {
    label: "Supplier Status",
    fields: "account_status_id",
    type: FILTER_TYPES.AccountStatus,
    dropdownOptionsFilter: {
      company_type: "SUPPLIER",
    },
    flexBasis: 250,
  },
 {
    label: "Range 1",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_1", "start_date_range_1", "end_date_range_1"],
    defaultValue: ["", "", ""],
    presets: BASE_DATE_RANGE_PRESETS,
  },
  {
    label: "Range 2",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_2", "start_date_range_2", "end_date_range_2"],
    defaultValue: ["", "", ""],
    dependsOn: { filterFields: ["category_date_range_1"] },
    presets: BASE_DATE_RANGE_PRESETS,
    presetPivots: PIVOT_DATE_RANGE_PRESETS,
  },

];
